import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Month, stringToDate } from "../../../../helpers/dateHelpers";
import { ISODateString } from "../../../../types/date";

interface WeekHeaderProps {
  meetingDate: ISODateString;
}

export const WeekHeader: React.FC<WeekHeaderProps> = ({ meetingDate }) => {
  const { i18n } = useTranslation();
  const date = stringToDate(meetingDate);

  return (
    <Card className="calendar-day">
      <Card.Header className="bg-primary text-white text-center text-uppercase fw-bold py-1 px-4">
        {Month.fromDateString(meetingDate).toLocaleMonthName(i18n.language)}
      </Card.Header>
      <Card.Body className="py-1 px-4 text-center">
        <span className="fs-1">{date.getDate()}</span>
      </Card.Body>
    </Card>
  );
};
